import React from 'react';
import useByteHooks from './byte-hook';
import { useNoAuthHooks } from '../../../../../../Hooks/hooks';
import { ICompanyResponse } from '../../../../../../Interfaces/responseTypes';
import { IDineInLocation } from '../../../../../../Interfaces/componentTypes';
import { VisitorPageContents } from '../../../visitorPage';
import CustomDialog from '../../../../../../Components/Dialog/customDialog';
import styles from './byte.module.scss';

interface IByteProps {
  type: VisitorPageContents,
  data: ICompanyResponse,
  dineInLocation?: IDineInLocation | null,
  dineInLocationFromUrl?: IDineInLocation | null,
}

const MrByte: React.FC<IByteProps> = (props) => {
  const { data, type, dineInLocation, dineInLocationFromUrl } = props;
  const { open, onCloseDialog, dialogComponent, contentType, renderFooter, renderPage } = useByteHooks(data, type, dineInLocation, dineInLocationFromUrl);
  const { mobileScreen } = useNoAuthHooks();
  
  return (
    <div className={styles.page}>
      {renderPage(contentType)}
      {
        data.business_profile && mobileScreen
        &&
        renderFooter()
      }
      <CustomDialog
        open={open}
        onClose={onCloseDialog}
        children={dialogComponent}
      />
    </div>
  )
};

export default MrByte
